module.exports = __webpack_public_path__ + "img/img_star.47fa96c9.png";